import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LanguageService } from '../../../core/language/language.service';

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {

    constructor(private languageService: LanguageService, private route: Router) {}

    changeSiteLanguage(language: string) {
        this.languageService.changeSiteLanguage(language);
        this.route.navigate(['/']);
    }
  }
